import '@innovatrics/dot-palm-capture';
import type { HTMLPalmCaptureElement, PalmConfiguration } from '@innovatrics/dot-palm-capture';

import { memo, useEffect } from 'react';

/*
 * SAIDVU-499/501 — real DOT web palm auto-capture (`@innovatrics/dot-palm-capture`).
 * Integrated exactly like `FaceCamera`/`@innovatrics/dot-face-auto-capture`: import registers
 * the `<x-dot-palm-capture>` custom element, and the live `configuration` (with the `onComplete`
 * callback + camera settings) is assigned imperatively on the element after render.
 *
 * WASM + models are served from `public/dot-assets/palm` (copied from the package), located via
 * `assetsDirectoryPath` (same mechanism the face component uses).
 */
const PalmCameraInner = (props: PalmConfiguration) => {
  useEffect(() => {
    const palmAutoCaptureHTMLElement = document.getElementById('x-dot-palm-capture') as HTMLPalmCaptureElement | null;

    if (palmAutoCaptureHTMLElement) {
      palmAutoCaptureHTMLElement.configuration = props;
    }
  });

  return <x-dot-palm-capture id="x-dot-palm-capture" />;
};

export const PalmCamera = memo(PalmCameraInner);
